import React from 'react'
import { NavLink } from 'react-router-dom'

export default function YourOrders() {
  return (
    <NavLink className={({ isActive }) => isActive ? "nav-item nav-link active" : "nav-item nav-link"} to="/orders">Your Orders</NavLink>
  )
}

